export default class ActivityMessageBase {
    activity_id: string
    activity_name: string
    activity_type: string
    // 活动指令
    activity_instruction: string
    instruction_order: number
    garden_id: string
    garden_name: string


    constructor(activity_id: string, activity_name: string, activity_type: string,
                instruction_order: number, garden_id: string, garden_name: string) {
        this.activity_id = activity_id
        this.activity_name = activity_name
        this.activity_type = activity_type
        this.instruction_order = instruction_order
        this.garden_id = garden_id
        this.garden_name = garden_name
    }
}
